module.exports = __webpack_public_path__ + "static/media/playIcon.581ae048.svg";